import script from "./TriageReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TriageReportsList.vue?vue&type=script&setup=true&lang=js"

import "./TriageReportsList.vue?vue&type=style&index=0&id=9d2b40a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d2b40a8"]])

export default __exports__